import { Component, EventEmitter, Output } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

interface CustomCellRendererParams extends ICellRendererParams {
  icons?: Icons[],
  onAction?: (param1, param2) => void,
  showIconRule?: (param) => boolean
}

type Icons = {
  name: string;
  action: string ;
  tooltip: string;
  color: string;
}

@Component({
  selector: 'app-actions-cell-renderer',
  template: `
    <div *ngIf="this.showActions" class="action-icons">
        <mat-icon
          *ngFor="let icon of icons"
          [svgIcon]="icon.name"
          [style.color]="icon.color"
          (click)="onActionClick(icon.action, $event)"
          matTooltip="{{ icon.tooltip }}"
        >
        </mat-icon>
    </div>
  `,
  styles: [`
    .action-icons {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      height: 100%
    }
    mat-icon {
      cursor: pointer;
      font-size: 20px;
      color: #555;
      transition: color 0.3s;
    }
    mat-icon:hover {
      color: #007bff;
    }
  `]
})
export class CustomActionsComponent {

  icons: Icons[] = [];
  showActions = true;
  params!: CustomCellRendererParams 
  
  agInit(params: ICellRendererParams ): void {
    this.params = params
    if(this.params.showIconRule){
        this.showActions = this.params.showIconRule(params);
    }
    if (this.params.data?.isSubtotal) {
      this.icons = [];
    } else {
      this.icons = this.params.icons as any;
    }
  }


  onActionClick(action: string, event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    if(this.params.onAction){
      this.params.onAction(action, this.params.data);
    }
  }
}
